<template>
  <div>
    <template v-if="$route.name !== 'search'"><header-interview></header-interview></template>
    <template v-else><main-header :userProfileData="userProfileData"></main-header></template>
    <div class="container-fluid bg-white" :class="productName">
        <router-view :key="$route.fullPath"></router-view>
        <!-- show quote summary button to show modal -->
        <div class="quote-summary-showbtn" v-if="showQuoteSummaryButton">
          <button type="button" class="btn btn-primary quote-summary" @click.prevent="showQuoteSummaryModal()">
            Show summary&nbsp;&nbsp;
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
              <path d="M0.198923 7.4803L5.69901 12.9804C5.96427 13.2456 6.39433 13.2456 6.65957 12.9804L7.30106 12.3389C7.56587 12.0741 7.56638 11.6449 7.30219 11.3794L2.94328 7.00001L7.30219 2.62061C7.56638 2.35517 7.56587 1.92599 7.30106 1.66118L6.65957 1.01969C6.3943 0.754424 5.96424 0.754424 5.69901 1.01969L0.198951 6.51974C-0.0663123 6.78498 -0.0663123 7.21504 0.198923 7.4803Z" fill="#003366"/>
            </svg>
          </button>
        </div>
        <!-- show quote summary button to hide modal -->
        <div class="quote-summary-hbtn" v-if="showHideQuoteSummaryButton">
          <button type="button" class="btn btn-primary quote-summary" @click.prevent="hideQuoteSummaryModal()">
            Hide summary&nbsp;&nbsp;
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
              <path d="M7.80108 7.4803L2.30099 12.9804C2.03573 13.2456 1.60567 13.2456 1.34043 12.9804L0.698941 12.3389C0.43413 12.0741 0.433621 11.6449 0.697809 11.3794L5.05672 7.00001L0.697809 2.6206C0.433621 2.35517 0.43413 1.92599 0.698941 1.66118L1.34043 1.01969C1.6057 0.754424 2.03576 0.754424 2.30099 1.01969L7.80105 6.51974C8.06631 6.78498 8.06631 7.21504 7.80108 7.4803Z" fill="#003366"/>
            </svg>
          </button>
        </div>
        <main-footer id="main-footer" role="contentinfo" class="mx-3 small" :class="{'bundle-flow': flowType === 'bundle' && $router.currentRoute.path.includes('/checkout')}"></main-footer>
        <div>
          <quote-summary></quote-summary>
        </div>
    </div>
    <div v-if="epicSuccess" class="alert alert-success alert-dismissible fade show epic-success" role="alert">
      <div class="row">
        <div class="d-inline-block float-left align-self-center mx-2 text-center">
          <span class="fas fa-check-circle epic-alert-icon"></span>
        </div>
        <div class="col px-0 d-inline-block">
          <h4>Success: Customer Quote Information Imported!</h4>
          <p>Some customer quote information has already been imported.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
/**
 * This is the parent component for all Interview components. Since it is the parent,
 * it will hold child components such as <help-script> and <quote-summary>.
 * <router-view> Vue Element will utilize the definitions set in ../../router/routes.js
 * to load the correct component depending on the URL.
 */
import Header from '../shared/Header';
import HeaderInterview from '../shared/HeaderInterview';
import Footer from '../shared/Footer';
import QuoteSummary from './shared/QuoteSummary';

export default {
  data() {
    return {
      property: 'testing',
      backgroundWhite: true,
      epicSuccess: false,
      userProfileData: { firstName: '', lastName: '' },
      flowType: '',
    };
  },
  methods: {
    updateQuoteSummaryStatus() {
      const formContainer = document.getElementById('form-container'); // TODO: Set once
      if (formContainer && formContainer.classList.contains('fixed-top') && this.$store.getters.getQuoteSummaryStatus) {
        formContainer.classList.add('quote-panel-scroll');
      } else if (formContainer && !this.$store.getters.getQuoteSummaryStatus) {
        formContainer.classList.remove('quote-panel-scroll');
      }
    },
    /** show quote summary modal on click */
    showQuoteSummaryModal() {
      this.$store.state.commonState.showQuoteSummaryStatus = true;
      sessionStorage.setItem('quoteSummaryStatus', 'visible');
      this.updateQuoteSummaryStatus();
    },
    /** Hide quote summary modal */
    hideQuoteSummaryModal() {
      this.$store.state.commonState.showQuoteSummaryStatus = false;
      sessionStorage.setItem('quoteSummaryStatus', 'hidden');
      this.updateQuoteSummaryStatus();
    },
  },
  components: {
    HeaderInterview,
    mainHeader: Header,
    quoteSummary: QuoteSummary,
    mainFooter: Footer,
  },
  computed: {
    showQuoteSummaryButton() {
      return sessionStorage.getItem('currentActionName') && sessionStorage.getItem('currentActionName') !== 'CreateQuote'
    },
    showHideQuoteSummaryButton() {
      return this.$store.getters.getQuoteSummaryStatus;
    },
    /**
    * return product name based on product flow
    */
    productName() {
      if (this.$route.path.includes('/home/')) {
        return 'home';
      } else if (this.$route.path.includes('/condo/')) {
        return 'condo';
      } else if (this.$route.path.includes('/renters/')) {
        return 'renters';
      } else if (this.$route.path.includes('/auto/')) {
        return 'auto';
      }
      return '';
    },
  },
  created() {
    this.flowType = sessionStorage.getItem('flowType');
    // class binding (set style) for class 'backgroundWhite' because ALL Interview pages except
    // CarrierMatch have a white background for the main form area
    if (this.$route.fullPath === '/carrier-matches') {
      this.backgroundWhite = false;
    }
    sessionStorage.setItem('epic', null);
    sessionStorage.setItem('epicSuccessAlertWasShown', null);
    if (JSON.parse(sessionStorage.getItem('redirectedFromEpicImport')) === true) {
      this.epicSuccess = true;
      setTimeout(() => {
        this.epicSuccess = false;
      }, 4000);
      sessionStorage.setItem('redirectedFromEpicImport', JSON.stringify(false));
    }
  },
  mounted() {
    this.userProfileData.firstName = sessionStorage.getItem('userFirstName');
    this.userProfileData.lastName = sessionStorage.getItem('userLastName');
  },
};
</script>
<style scoped lang="scss">
.quote-summary-showbtn {
  .btn.quote-summary {
    position: fixed;
    right: 10px;
    bottom: 10px;
    font-size: 12px;
    border-radius: 4px;
    background-color: #FFFFFF;
    color: #003366;
    border-color: #003366;
    text-transform: none;
    min-width: 148px;
    font-weight: 400;
    z-index: 110;
    &:focus {
      background-color: #FFFFFF !important;
      color: #003366 !important;
      box-shadow: none !important;
    }
  }
}
.quote-summary-hbtn {  
  .btn.quote-summary {
    position: fixed;
    right: 10px;
    bottom: 10px;
    z-index: 1051;
    font-size: 12px;
    border-radius: 4px;
    background-color: #FFFFFF;
    color: #003366;
    border-color: #003366;
    text-transform: none;
    min-width: 148px;
    font-weight: 400;
    &:focus {
      background-color: #FFFFFF !important;
      color: #003366 !important;
      box-shadow: none !important;
    }
  }
}
.backgroundWhite {
  background-color: #fff;
}
.epic-success {
  position: fixed !important;
  top: 1rem;
  left: 35%;
  width: 30%;
  height: auto;
  z-index: 1100;
  color: #1A1A1A;
  background-color: #ECF8EB;
  border: 2px solid #2E7B32 !important;
  .epic-alert-icon {
    font-size: 25px;
    color: #2E7B32;
  }
  h4 {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/interview/Interview.vue?faff1fa0